module.exports = __webpack_public_path__ + "static/media/icon+des.0478a858.svg";